import { useEffect } from "react";

export const useTabFromQuery = (setSelectedTab: (tab: string) => void) => {
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tab = queryParams.get("tab");

    if (tab) {
      queryParams.delete("tab");
      window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
      setSelectedTab(tab);
    }
  }, [setSelectedTab]);
};
